import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { ref } from 'vue'
import { useMsgStore } from '@/stores/msg'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: ['placeholder'],
  setup(__props) {

const props = __props

const options: any = ref([])

const loading = ref(false)
const visibleChange = async (visible: boolean) => {
  if (visible && options.value.length === 0) {
    loading.value = true
    const msgStore = useMsgStore()
    msgStore.queryType().finally(() => {
      options.value = msgStore.msgType
      loading.value = false
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    class: "ws_select",
    placeholder: props.placeholder,
    loading: loading.value,
    onVisibleChange: visibleChange,
    clearable: "",
    filterable: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.code,
          label: item.name,
          value: item.code
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["placeholder", "loading"]))
}
}

})